module.exports = __webpack_public_path__ + "static/media/point-icon-1.a0811f71.png";